// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f7ada1c5428b0ca86026","532":"8954b903b7cd01f21ad4","691":"b27827fcd381ddef50fd"}[chunkId] + ".js";
};